import { useCallback } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Box } from '@mui/material';
import { useEventListener } from 'usehooks-ts';
import { PageLayout } from 'components/PageLayout';
import { isPhone } from 'shared/envUtils';
import { ForcedTheme } from 'components/ForcedTheme';
import { CameraFullscreenDetails } from './CameraFullscreenDetails';
import { MobileFullscreenCamera } from './MobileFullscreenCamera';

export const FullscreenCamera = (
  props: RouteComponentProps<{ cameraId: string }>,
): JSX.Element => {
  const {
    history,
    match: {
      params: { cameraId },
    },
  } = props;

  useEventListener(
    'keydown',
    useCallback(
      (event: KeyboardEvent): void => {
        if (event.key === 'Escape') {
          history.push('/');
        }
      },
      [history],
    ),
    { current: document },
    { capture: true },
  );

  return (
    <ForcedTheme mode="dark">
      <PageLayout
        data-cname="FullscreenCameraPage"
        allowAppBanner={false}
        headerBarProps={
          isPhone() ? undefined : { action: `/camera/${cameraId}` }
        }
      >
        <Box
          sx={{
            bgcolor: 'background.default',
            height: '100%',
            width: '100%',
            minHeight: 0,
          }}
        >
          {isPhone() ? <MobileFullscreenCamera /> : <CameraFullscreenDetails />}
        </Box>
      </PageLayout>
    </ForcedTheme>
  );
};
